import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { ControlSelect, DatePicker, Form } from "../index";

export const ComplementResultsFilter = ({
  filterOptions,
  dateRange,
  onFilterChange,
  onDateRangeChange,
}) => {
  const methods = useFormContext();
  const watchedFilterType = useWatch({
    control: methods.control,
    name: "filterType",
  });

  const filterSelectOptions = [
    { value: "current", label: "Aktuální výsledky" },
    { value: "last100", label: "Posledních 100 výsledků" },
    { value: "all", label: "Všechny výsledky" },
    { value: "custom", label: "Dle data" },
  ];

  // Sledovanie zmien v ControlSelect pomocou useWatch
  React.useEffect(() => {
    if (
      watchedFilterType &&
      watchedFilterType.value &&
      watchedFilterType.value !== filterOptions
    ) {
      onFilterChange(watchedFilterType.value);
    }
  }, [watchedFilterType]);

  const handleDateFromChange = (date) => {
    const dateString = date ? date.toISOString().split("T")[0] : "";
    methods.setValue("dateFrom", dateString);
    onDateRangeChange({
      ...dateRange,
      from: dateString,
    });
  };

  const handleDateToChange = (date) => {
    const dateString = date ? date.toISOString().split("T")[0] : "";
    methods.setValue("dateTo", dateString);
    onDateRangeChange({
      ...dateRange,
      to: dateString,
    });
  };

  return (
    <div className="complement-results-filter">
      <Form>
        <div className="filter-row">
          <div className="filter-group">
            <ControlSelect
              name="filterType"
              label="Časové období:"
              options={filterSelectOptions}
              placeholder="Vyberte období..."
              containerClass="filter-group"
              labelClass="filter-label"
              width={300}
            />
          </div>

          {(filterOptions === "custom" ||
            watchedFilterType?.value === "custom") && (
            <div className="date-range-group">
              <DatePicker
                name="dateFrom"
                label="Datum výsledků od:"
                labelClass="filter-label"
                onChange={handleDateFromChange}
              />
              <DatePicker
                name="dateTo"
                label="Datum výsledků do:"
                labelClass="filter-label"
                onChange={handleDateToChange}
              />
            </div>
          )}
        </div>
      </Form>
    </div>
  );
};
